import classNames from 'classnames';
import Image from 'components/shared/image';
import VideoPlayer from 'components/shared/video/video';
import SiteLink from 'components/shared/sitelink';
import { addLocaleToHref } from 'lib/utils/helpers';
import renderInlineItalic from 'lib/utils/renderInlineItalic';
import styles from './mediaGrid.module.scss';

const MediaGrid = ({ data, locale }) => {
  const { components, title, anchorId } = data || {};

  return (
    <section id={anchorId} className={styles.wrapper}>
      {title && <h2 className={styles.title}>{title}</h2>}
      <div className={styles.grid}>
        {components.map(banner => {
          const { media, link, text, textColor, textColorMobile } = banner || {};
          return (
            <div
              key={`MediaGridBanner-${banner.id}`}
              className={styles.banner}
              style={{
                '--text-color': textColor === 'White' ? '#FFFFFF' : '#000000',
                '--text-color-mobile': textColorMobile === 'White' ? '#FFFFFF' : '#000000',
                '--underline-color':
                  textColor === 'White' ? 'rgba(255, 255, 255, 0.4)' : 'rgba(0, 0, 0, 0.15)',
                '--underline-color-mobile':
                  textColorMobile === 'White' ? 'rgba(255, 255, 255, 0.4)' : 'rgba(0, 0, 0, 0.15)',
              }}
            >
              <div className={styles.mediaContainer}>
                {media?.type === 'Video' && media?.video ? (
                  <VideoPlayer
                    className={classNames(styles.media)}
                    thumbnail={media?.thumbnail}
                    source={media.video}
                    sourceDesktop={media.videoDesktop}
                    autoPlay
                    controls={false}
                    forceKeepPlaying
                  />
                ) : (
                  <Image src={media.image} layout="fill" className={styles.media} loading="lazy" />
                )}
              </div>
              <SiteLink
                className={styles.content}
                aria-label={link?.text}
                href={addLocaleToHref(link?.link?.slug, locale)}
              >
                <span className={styles.bannerText}>{renderInlineItalic(text)}</span>
              </SiteLink>
            </div>
          );
        })}
      </div>
    </section>
  );
};

export default MediaGrid;
